import { createStyles } from 'antd-style'

import { useThemeMode } from 'src/theme'

/** Display name for alt text, aria labels, and mailto subjects. */
export const BRAND_NAME = 'Skalx AI'

export const BRAND_LOGO_SRC = '/logo.svg'
export const BRAND_LOGO_DARK_SRC = '/logo_white_letters.svg'

const useBrandStyles = createStyles(() => ({
  img: {
    display: 'block',
    objectFit: 'contain' as const,
    flexShrink: 0
  },
  /** App sidebar (expanded sider): compact, left-aligned wordmark. */
  expanded: {
    height: 'auto',
    maxHeight: 18,
    width: 'auto',
    maxWidth: '100%',
    objectPosition: 'left center'
  },
  /** App sidebar (collapsed sider): same cap, left-aligned (no horizontal centering). */
  collapsed: {
    height: 'auto',
    maxHeight: 18,
    width: 'auto',
    maxWidth: '100%',
    objectPosition: 'left center'
  },
  /** Login / auth screens: compact wordmark (wide SVG scales by width). */
  auth: {
    maxHeight: 20
  }
}))

type Props = {
  variant: 'expanded' | 'collapsed' | 'auth'
}

export const BrandWordmark = ({ variant }: Props) => {
  const { styles, cx } = useBrandStyles()
  const { mode } = useThemeMode()
  const src = mode === 'dark' ? BRAND_LOGO_DARK_SRC : BRAND_LOGO_SRC

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={cx(
        styles.img,
        variant === 'expanded' && styles.expanded,
        variant === 'collapsed' && styles.collapsed,
        variant === 'auth' && styles.auth
      )}
    />
  )
}
